import { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { agreeOptionalTerm } from '@/api/adapters/terms-policies';

import { MY_TERMS_LIST_QUERY_KEY, useStaffTermsList } from './use-terms';

// Opt-in state for optional (선택) terms, sourced from the SERVER list (GET /me/terms), not the
// browser. `agreed` is the set of typeIds this staff has agreed to for the current published
// version; it drives the [동의하기] button's visibility only (never an "agreed" status label).
// `agree` records the opt-in server-side, then invalidates the list so `agreed` reflects the
// server — which is what removes the button for that row.
export function useOptionalConsent() {
  const queryClient = useQueryClient();
  const { data: terms } = useStaffTermsList();

  const agreed = useMemo(
    () => new Set((terms ?? []).filter((t) => t.agreed).map((t) => t.typeId)),
    [terms],
  );

  const agree = useCallback(
    async (typeId: number) => {
      await agreeOptionalTerm(typeId);
      await queryClient.invalidateQueries({ queryKey: MY_TERMS_LIST_QUERY_KEY });
    },
    [queryClient],
  );

  return { agreed, agree };
}
